'use client'

export const NinjaWhite = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={32}
    viewBox="0 0 150 150"
    fill="none"
    shapeRendering="geometricPrecision"
    {...props}>
    <path
      fill="#ffff"
      d="M82.927 0c-7.342 51.946-26.828 71.23-35.652 71.23v7.54c19.226.001 17.758 47.431 14.42 71.228H29.297v.003H0V0h82.927ZM150 150.001h-29.3v-.003H69.237v-.001h.003c7.341-51.945 27.165-71.224 35.65-71.227v-7.54C85.664 71.229 87.133 23.798 90.47 0H150v150.001Z"
    />
  </svg>
)
